/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P3_TodayInputs */

const en_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const ar_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اليوم`)
};

const de_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute`)
};

const es_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy`)
};

const fr_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

const it_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi`)
};

const ja_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本日`)
};

const ko_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘`)
};

const pt_br_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const ru_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегодня`)
};

const th_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันนี้`)
};

const tr_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugün`)
};

const zh_cn_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天`)
};

const zh_tw_subscription_walkthrough_p3_today = /** @type {(inputs: Subscription_Walkthrough_P3_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Subscription_Walkthrough_P3_TodayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p3_today = /** @type {((inputs?: Subscription_Walkthrough_P3_TodayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P3_TodayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p3_today(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p3_today(inputs)
	if (locale === "de") return de_subscription_walkthrough_p3_today(inputs)
	if (locale === "es") return es_subscription_walkthrough_p3_today(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p3_today(inputs)
	if (locale === "it") return it_subscription_walkthrough_p3_today(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p3_today(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p3_today(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p3_today(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p3_today(inputs)
	if (locale === "th") return th_subscription_walkthrough_p3_today(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p3_today(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p3_today(inputs)
	return zh_tw_subscription_walkthrough_p3_today(inputs)
});